export const RELATION_TYPE = {
  parent: "parent",
  subsidiary: "subsidiary",
} as const;
